module.exports = __webpack_public_path__ + "img/fashion_41.0ee80a3a.jpg";